import { render, staticRenderFns } from "./storePurStockOrder.vue?vue&type=template&id=fbd80316&"
import script from "./storePurStockOrder.vue?vue&type=script&lang=js&"
export * from "./storePurStockOrder.vue?vue&type=script&lang=js&"
import style0 from "./storePurStockOrder.vue?vue&type=style&index=0&id=fbd80316&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports